// extracted by mini-css-extract-plugin
export default {"container":"Title_container__7Nlhv","title":"Title_title__iF73g"};